import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";
export function DownloadSharpIcon (props: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...props} data-testid="DownloadSharpIcon">
            
  <path d="M12 16.5L7 11.5L8.4 10.05L11 12.65V4.5H13V12.65L15.6 10.05L17 11.5L12 16.5ZM4 20.5V15.5H6V18.5H18V15.5H20V20.5H4Z" />

        </SvgIcon>
    )
}
        